import React from "react";
import Datastudio from "./Datastudio";
import PowerBi from "./PowerBi";

const KlayivoData = () =>  {

    return (
      <PowerBi title='Klaviyo Data' resource='klaviyo'/>
    );
}
export default KlayivoData;